<style lang="scss">
.image-input-container-edit {
  margin-bottom: 10px;
  .image-input-edit {
    input {
      display: inline;
    }
  }
}
.campaign-image {
  display: inline-block;
  max-width: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  img {
    max-width: 100%;
  }
}

textarea{
  resize: none;
}

</style>

<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content container">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h2 class="modal-title" id="myModalLabel">
            Edit Pairing Brief
          </h2>
        </div>

        <!-- Popup content -->
        <div class="modal-body" v-if="campaignId !== null">
          <!-- Form -->
            <div v-for="section in pairingBriefModelSections" :name="section.title" :key="section.type">
              <div class="row">
                <h3>{{section.title}}</h3>
                <!-- Dynamically generate campaign input fields -->
                <element v-for="(campaignField, index) in section.content" :key="index">
                  <div class="form-group col-xs-12 col-sm-6" v-if="campaignField.type === 'text'" v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }">
                    <label>{{ campaignField.label }}</label>
                    <input type="text" class="form-control" :placeholder="campaignField.placeholder" v-model="campaign[campaignField.name]" @input="$v.campaign[campaignField.name].$touch()">
                    <span class="help-block" v-for="(validation, index) in campaignField.validations" :key="index" >
                      <span v-if="$v.campaign[campaignField.name] && !$v.campaign[campaignField.name][validation.name] && $v.campaign[campaignField.name].$error">
                        {{ validation.message }}
                      </span>
                    </span>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6" v-if="campaignField.type === 'textarea'" v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }">
                    <label>{{ campaignField.label }}</label>
                    <textarea type="text" row="5" class="form-control" :placeholder="campaignField.placeholder" v-model="campaign[campaignField.name]" @input="$v.campaign[campaignField.name].$touch()">
                    </textarea>
                    <span class="help-block" v-for="(validation, index) in campaignField.validations" :key="index">
                      <span v-if="$v.campaign[campaignField.name] && !$v.campaign[campaignField.name][validation.name] && $v.campaign[campaignField.name].$error">
                        {{ validation.message }}
                      </span>                      
                    </span>
                  </div>

                  <div class="form-group col-xs-12 col-sm-6" v-if="campaignField.type === 'select'">
                    <label>{{ campaignField.label }}</label>
                    <select class="form-control" :name="campaignField.name" v-model="campaign[campaignField.name]">
                      <option v-for="(option, index) in campaignField.value" :key="index" v-bind:value="option.value" :selected="{ selected: option.selected }">
                        {{ option.text }}
                      </option>
                    </select>
                  </div>

                  <element v-if="campaignField.type === 'multiple_options'">
                    <div class="form-group col-xs-12">
                      <div class="form-group col-xs-12" v-for="(option, optionIndex) in campaign[campaignField.name]" :key="optionIndex">
                        <div class="form-group col-xs-12">
                          <h4>{{ campaignField.label }} {{ optionIndex + 1 }}</h4>
                          <b-button variant="danger" size="sm" v-if="campaign[campaignField.name].length > 1" @click.stop="deleteOption(campaignField.name, optionIndex)">
                            <i class="fa fa-trash ims-text-error"></i>
                          </b-button>
                        </div>
                        <element v-for="(optionField, index) in campaignField.template" :key="index">
                          <div class="form-group col-xs-12 col-sm-6" v-if="optionField.type == 'text'">
                            <label>{{ optionField.label }}</label>
                            <input type="text" class="form-control" v-model="campaign[campaignField.name][optionIndex][optionField.name]" :placeholder="optionField.placeholder">
                          </div>
                          <div class="form-group col-xs-12 col-sm-6" v-if="optionField.type == 'textarea'">
                            <label>{{ optionField.label }}</label>
                            <textarea type="text" class="form-control" v-model="campaign[campaignField.name][optionIndex][optionField.name]" :placeholder="optionField.placeholder">
                            </textarea>
                          </div>
                          <div class="form-group col-xs-12 col-sm-6" v-if="optionField.type == 'upload'">
                            <label>{{ optionField.label }}</label>
                            <div class="col-xs-12">
                              <div v-for="(image, i) in campaign[campaignField.name][optionIndex][optionField.name]" :key="image">
                                <div v-if="image != ''" >
                                  <a :href="constructImageURL(image)" target="_blank" class="campaign-image">
                                  <img style="width:100%" :src="constructImageURL(image)">
                                </a>
                                <button type="button" class="btn btn-link btn-link-danger" @click.prevent="removeImage(optionIndex, i)">Remove</button>
                                </div>                                
                              </div>
                            </div>
                            <div class="col-xs-12">
                              <div class="image-input-container-edit" :data-index="optionIndex">
                                <div class="image-input-edit">
                                  <input type="file" ref="files" />
                                  <button type="button" class="btn btn-link btn-link-danger btn-remove-input-edit">Remove</button>
                                </div>
                              </div>
                              <button type="button" class="btn btn-default btn-sm btn-add-more-image-edit">+ Add more image</button>
                            </div>
                          </div>
                        <div class="form-group col-xs-12 col-sm-6" v-if="optionField.type === 'select'">
                          <label>{{ optionField.label }}</label>
                          <select class="form-control" :name="optionField.name" v-model="campaign[campaignField.name][optionIndex][optionField.name]">
                            <option v-for="(option, index) in optionField.value" :key="index" v-bind:value="option.value" :selected="{ selected: option.selected }">
                              {{ option.text }}
                            </option>
                          </select>
                        </div>                          
                        </element>
                      </div>
                      <div class="form-group col-xs-12">
                        <button type="button" class="btn btn-primary" @click="addOption(campaignField.name)">
                          Add new option
                        </button>
                      </div>
                    </div>
                  </element>
                </element>
              </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default secondary--text" data-dismiss="modal" ref="closeButton">
            Close
          </button>
          <button type="button" class="btn btn-primary primary--text" @click="editCampaign">
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import campaignConfig from './config'
import campaignAPIs from './campaignAPIs'

const campaignDataTemplate = {}

export default {
  name: 'EditPairingBriefModal',
  props: ['modalId', 'campaignId'],
  data() {
    return {
      campaign: {},
      pairingBriefModelSections: campaignConfig.pairingBriefModelSections,
      pairingBriefModelSectionType: campaignConfig.pairingBriefModelSectionType
    }
  },
  watch: {
    campaignId: function(newCampaignId) {
      campaignAPIs
        .getCampaign(newCampaignId)
        .then(response => {
          response.angles = response.angles.map(angle => {
            const cpAngle = Object.assign({}, angle)
            const sampleImages = angle.sample_images ? angle.sample_images : []
            if (cpAngle.sample_image) {
              sampleImages.push(cpAngle.sample_image)
            }
            delete cpAngle.sample_images
            delete cpAngle.sample_image
            cpAngle.sample_images = sampleImages
            return cpAngle
          })
          this.campaign = Object.assign(campaignDataTemplate, response)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    }
  },
  validations: function() {
    const validationRules = {
      campaign: {}
    }
    this.pairingBriefModelSections.forEach(section => {
      section.content.forEach(field => {
        if (field.validations && field.validations.length > 0) {
          if (field.validations) {
            field.validations.forEach(validation => {
              validationRules['campaign'][field.name] = {
                [validation.name]: validation.value
              }
            })
          }
        }
      })
    })

    return validationRules
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
  },
  methods: {
    editCampaign: function() {
      const fileData = {}
      $('.image-input-edit input').each(function(i, el) {
        const input = $(el)
        if (input[0].files.length > 0) {
          const index = input
            .parent()
            .parent()
            .data('index')
          if (fileData[index] === undefined) {
            fileData[index] = []
          }
          fileData[index].push(input[0].files[0])
        }
      })

      const campaign = Object.assign({}, this.campaign)
      const campaignID = campaign.id

      // Delete companyID and clientID, we will let the server derive the values themselves
      delete campaign.companyID
      delete campaign.clientID
      delete campaign.id

      let formData = new FormData()
      let sampleImageList = []
      formData.append('campaign', JSON.stringify(campaign))
      for (var i in fileData) {
        for (var j in fileData[i]) {
          sampleImageList.push(`${i}_${j}`)
        }
      }
      // This is to make sure that file input is appended at last
      formData.append('sampleImageList', JSON.stringify(sampleImageList))

      for (i in fileData) {
        for (j in fileData[i]) {
          // sampleImageList.push(`${i}_${j}`)
          formData.append(`sampleImage_${i}_${j}`, fileData[i][j])
        }
      }

      // Edit campaign
      campaignAPIs
        .editCampaign(campaignID, formData)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('editCampaign', response)

          // Dismiss modal by triggering the click event on Close button
          this.$refs.closeButton.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    deleteOption: function(campaignAttribute, campaignAttributeIndex) {
      var campaignOptions = this.campaign[campaignAttribute]
      if (campaignAttributeIndex < campaignOptions.length) {
        campaignOptions.splice(campaignAttributeIndex, 1)
        this.campaign[campaignAttribute] = campaignOptions
      }
    },
    addOption: function(campaignAttribute) {
      var campaignOptions = this.campaign[campaignAttribute]
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {}

        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = ''
        }

        campaignOptions.push(campaignOptionsTemplate)
        this.campaign[campaignAttribute] = campaignOptions
      }
    },
    constructImageURL: function(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName
    },
    clearData: function() {
      this.campaign = {
        name: '',
        goal: '',
        budget: ''
      }
    },
    initFileUpload() {
      $(document).on('click', '.btn-add-more-image-edit', function(event) {
        event.preventDefault()
        $(this).prev('.image-input-container-edit').append(`
          <div class="image-input">
            <input type="file" ref="files"/>
            <button type="button" class="btn btn-link btn-link-danger btn-remove-input-edit">Remove</button>
          </div>
        `)
      })

      $(document).on('click', '.btn-remove-input-edit', function() {
        $(this)
          .parent()
          .remove()
      })
    },
    removeImage(optionIndex, i) {
      this.campaign.angles[optionIndex].sample_images.splice(i, 1)
    }
  },
  mounted() {
    this.initFileUpload()
  },
  beforeCreate() {
    // Update campaign data value based on campaign model
    campaignConfig.pairingBriefModelSections.forEach(section => {
      section.content.forEach(field => {
        campaignDataTemplate[field.name] = ''
        if (field.type === 'select') {
          campaignDataTemplate[field.name] = field.defaultValue
        } else if (field.type === 'multiple_options') {
          var newOption = {}
          field.template.forEach(template => {
            newOption[template.name] = ''
          })
          campaignDataTemplate[field.name] = [newOption]
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// EditPairingBriefModal.vue?3d5990a8